import { render, staticRenderFns } from "./customerFeaturesConfig.vue?vue&type=template&id=a672f142&scoped=true"
import script from "./customerFeaturesConfig.vue?vue&type=script&lang=js"
export * from "./customerFeaturesConfig.vue?vue&type=script&lang=js"
import style0 from "./customerFeaturesConfig.vue?vue&type=style&index=0&id=a672f142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a672f142",
  null
  
)

export default component.exports